import React from 'react';
import { BodyText } from '../../atoms';
import { formatExpirationYear } from './utils';
import { CreditCardHolderDetailsWrapper } from './CreditCardHolderDetails.styles';

export type CreditCardHolderDetailsProps = {
  /**
   * First name
   */
  firstName: string;
  /**
   * Last name
   */
  lastName: string;
  /**
   * Card expiration month
   */
  expirationMonth: number;
  /**
   * Card expiration year
   */
  expirationYear: number;
};

const CreditCardHolderDetails = ({
  firstName,
  lastName,
  expirationMonth,
  expirationYear,
}: CreditCardHolderDetailsProps) => {
  return (
    <CreditCardHolderDetailsWrapper>
      <BodyText variant="body2" overflow="truncate" color="inherit">
        {firstName ? firstName : ''}
        {firstName && lastName ? ' ' : ''}
        {lastName ? lastName : ''}
      </BodyText>
      <BodyText variant="body2" color="inherit">
        {expirationMonth > 9 ? expirationMonth : `0${expirationMonth}`}/
        {formatExpirationYear(expirationYear)}
      </BodyText>
    </CreditCardHolderDetailsWrapper>
  );
};

export default CreditCardHolderDetails;
